<template>
  <div>
    积分明细
  </div>
</template>
<script>
export default {
  name: 'DdtMallPointsDetails',
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
</style>